import React, { useState, useEffect, useRef } from 'react';
import TextField from '../TextField/TextField';
import Button from '../../Button/Button';
import { getCountries, getCountryCallingCode } from 'react-phone-number-input/input';
import en from 'react-phone-number-input/locale/en.json';
import './countrySelect.css';

const CountrySelect = ({ value, onChange, error }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState('');
  const popoverRef = useRef(null);

  const countries = getCountries();

  const filteredCountries = countries.filter(country => 
    en[country].toLowerCase().includes(search.toLowerCase()) ||
    getCountryCallingCode(country).includes(search)
  );

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popoverRef.current && !popoverRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleCountrySelect = (country) => {
    onChange(`+${getCountryCallingCode(country)}`);
    setIsOpen(false);
  };

  return (
    <div className="country-select" ref={popoverRef}>
      <TextField
        label="Landcode"
        variant="outlined"
        placeholder="+31"
        value={value}
        onClick={() => setIsOpen(true)}
        readOnly
        error={error}
      />
      {isOpen && (
        <div className="country-select-popover">
          <TextField
            placeholder="Search countries"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <div className="country-list">
            {filteredCountries.map(country => (
              <Button
                key={country}
                variant="text"
                onClick={() => handleCountrySelect(country)}
                className="country-item"
              >
                <div className="country-item-content">
                  <div className="country-item-left">
                    <span className={`fi fi-${country.toLowerCase()}`}></span>
                    <span className="country-name">{en[country]}</span>
                  </div>
                  <div className="country-item-right">
                    <span>+{getCountryCallingCode(country)}</span>
                  </div>
                </div>
              </Button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default CountrySelect;